import React from 'react';
import Nav from '../../Page Components/Nav';
import Footer from "../../Page Components/Footer";
import Card from "../../Co Components/SquareCards";
import Square from "../../Co Components/SquareCards";
import Title from "../../Co Components/Titles";
import homehero from '../../assets/Images/homehero.png';
import Rectangle from "../../Co Components/RectangleCards";
import LineButton from "../../Co Components/LineButton";
import hackerGreen from '../../assets/Images/hacker-2.png';
import BlogCard from "../../Co Components/BlogCards";
import HomeCard from "../../Co Components/HomeCards";
import PrimaryButton from "../../Co Components/PrimaryButton";
import SecondaryButton from "../../Co Components/SecondaryButton";
import hackerRed from "../../assets/Images/hacker.png";
const Mobile = () => {

    return (
        <>

            <Nav />
            <section className={' d-flex flex-row mt-0  align-items-center w-90 '}>
                <article>
                    <div className={'mx-5 w-75'}>
                        <h1 className={'bebas display-1 text-black bolde  line-normal'}>WhiteGuard
                            <span className={'bebas green'}><br /> Mobile Application</span><br />
                            Services</h1>
                    </div>

                    <div className={'w-75 mx-5'}>
                        <p className={'bolder h6'} >
                            Uncover the hidden vulnerabilities in your application's security
                            and improve your security posture with real penetration testing experience driven
                            by great human minds, not automated scanners.
                        </p>
                    </div>
                </article>
                <figure className=' headerImage align-self-center d-flex flex-column w-25'>
                    <HomeCard className={'success'} />
                    <img src={hackerGreen} className={'hackerImage z-1'} />
                </figure>

            </section>


            <Title className={'mt-6'} header={"the"} body={"Benefits"} />
            <div className={'d-flex mb-5  flex-row justify-content-center align-items-center flex-wrap'}>
                <Square className={'mx-4 cardGreen mt-5'} Title={"Mobile Application"} text={'Some quick example text to build on the card title and make up the\n' +
                    '          bulk of the card\'s content.'} />
                <Square className={'mx-4 cardGreen mt-5'} Title={"Mobile Application"} />
                <Square className={'mx-4 cardGreen mt-5'} Title={"Mobile Application"} />

                <Square className={'mx-4 cardGreen mt-5'} Title={"Mobile Application"} text={'Some quick example text to build on the card title and make up the\n' +
                    '          bulk of the card\'s content.'} />
                <Square className={'mx-4 cardGreen mt-5'} Title={"Mobile Application"} />
                <Square className={'mx-4 cardGreen mt-5'} Title={"Mobile Application"} />
            </div>
            <Title className={'mt-6'} header={"the"} body={"Process"} />
            <div className={'d-flex flex-column align-items-center justify-content-start process-container'} style={{ transition: 'all 0.3s ease' }}>
                <Rectangle className={'mt-4 cardGreen'} Title={'Mobile Application'} text={'Some quick example text to build on the card title and make up the\n' +
                    '          bulk of the card\'s content. Some quick example text to build on the card title and make up the\n' +
                    '          bulk of the card\'s content. Some quick example text to build on the card title and make up the\n' +
                    '          bulk of the card\'s content.'} />
                <Rectangle className={'mt-4 cardGreen'} Title={'Mobile Application'} text={'sdmgkmgkmgegmmkwg'} />
                <Rectangle className={'mt-4 cardGreen'} Title={'Mobile Application'} text={'sdmgkmgkmgegmmkwg'} />
            </div>


            <Footer />
        </>
    );

}

export default Mobile;